import React from "react";
import { animation, duration } from "../../../utils/utils";
import { Modal, TransitionablePortal } from "semantic-ui-react";

const MoreInfoModal = (props) => {
  return (
    <TransitionablePortal
      transition={{ animation, duration }}
      open={props.open}
      onClose={() => props.close()}
    >
      <Modal
        onClose={props.close}
        open={props.open}
        size="small"
        closeIcon
        className="reminder-list-modal"
      >
        <Modal.Header>{props.reminder?.title}</Modal.Header>
        <Modal.Content scrolling>
          <p>{props.reminder?.content}</p>
        </Modal.Content>
      </Modal>
    </TransitionablePortal>
  );
};

export default MoreInfoModal;
